import { AdminOrder, AdminOrderStatus } from '../../../mocks/adminOrders';

interface StatsCardsProps {
  orders: AdminOrder[];
}

export default function StatsCards({ orders }: StatsCardsProps) {
  const totalRevenue = orders
    .filter((o) => o.status === 'delivered')
    .reduce((sum, o) => sum + o.total, 0);

  const countByStatus = (s: AdminOrderStatus) => orders.filter((o) => o.status === s).length;

  const stats = [
    {
      label: 'Total Orders',
      value: orders.length,
      icon: 'ri-file-list-3-line',
      color: 'text-stone-700',
      bg: 'bg-stone-100',
    },
    {
      label: 'Pending',
      value: countByStatus('pending'),
      icon: 'ri-time-line',
      color: 'text-amber-600',
      bg: 'bg-amber-50',
    },
    {
      label: 'On the Way',
      value: countByStatus('on_way'),
      icon: 'ri-motorbike-line',
      color: 'text-blue-600',
      bg: 'bg-blue-50',
    },
    {
      label: 'Delivered',
      value: countByStatus('delivered'),
      icon: 'ri-checkbox-circle-line',
      color: 'text-green-600',
      bg: 'bg-green-50',
    },
    {
      label: 'Revenue',
      value: `$${totalRevenue.toLocaleString()}`,
      icon: 'ri-money-dollar-circle-line',
      color: 'text-orange-600',
      bg: 'bg-orange-50',
    },
  ];

  return (
    <div className="grid grid-cols-5 gap-4">
      {stats.map((s) => (
        <div key={s.label} className="bg-white rounded-xl border border-stone-200 px-5 py-4 flex items-center gap-4">
          <div className={`w-10 h-10 rounded-lg ${s.bg} flex items-center justify-center shrink-0`}>
            <i className={`${s.icon} ${s.color} text-lg`} />
          </div>
          <div>
            <p className="text-xs text-stone-400 font-medium">{s.label}</p>
            <p className="text-xl font-bold text-stone-900 leading-tight">{s.value}</p>
          </div>
        </div>
      ))}
    </div>
  );
}
